import Table from "react-bootstrap/Table";
import { AxisDateTimeFull } from "../util/AxisDateTime";
import React, { Fragment, useEffect, useState } from "react";
import Badge from "react-bootstrap/Badge";
import { useAuth } from "../context/AuthContext";
import AxisSpinner from "./AxisSpinner";
import { ShiftTableTitle } from "./ShiftTableTitle";
import { UserLink } from "../util/Links";

const RefereeEventsElement = ({ refereeId, user, refreshTrigger }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    if (refereeId && user?.id) {
      fetchEvents();
    }
  }, [refereeId, user?.id, refreshTrigger]);

  const fetchEvents = async () => {
    if (!refereeId || !user?.id) return;
    
    try {
      setLoading(true);
      const config = {
        headers: { "content-type": "application/json" },
        params: { 
          user_id: user.id,
          referee_id: refereeId 
        },
      };

      const response = await authAxios().get(
        "/api/backoffice/users/references/events",
        config
      );

      setEvents(response.data.content || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error fetching referee events:", error);
    }
  };

  const getEventTypeBadge = (eventType) => {
    const eventColors = {
      created: "success",
      updated: "primary",
      sent: "info",
      delivered: "warning",
      completed: "success",
      declined: "danger",
      voided: "secondary",
      expired: "dark"
    };

    return (
      <Badge bg={eventColors[eventType] || "secondary"} className="text-capitalize">
        {eventType}
      </Badge>
    );
  };

  if (!refereeId) return null;

  return (
    <Fragment>
      <ShiftTableTitle title={"Event History"} />
      {loading ? (
        <div className="text-center py-4">
          <AxisSpinner loading={loading} />
        </div>
      ) : events.length === 0 ? (
        <div className="text-center py-4 text-muted">
          <p>No events recorded for this reference.</p>
        </div>
      ) : (
        <Table striped hover responsive>
          <thead>
            <tr>
              <th>Event</th>
              <th>User</th>
              <th>External UUID</th>
              <th>Email</th>
              <th>Reject Reason</th>
              <th>Happened At</th>
              <th>Received At</th>
            </tr>
          </thead>
          <tbody>
            {events.map((event) => (
              <tr key={event?.id}>
                <td>
                  {getEventTypeBadge(event?.event)}
                </td>
                <td>
                  {event?.user ? (
                    UserLink(event.user)
                  ) : (
                    <span className="text-muted">-</span>
                  )}
                </td>
                <td>
                  {event?.externalUuid ? (
                    <span className="font-monospace small">
                      {event.externalUuid}
                    </span>
                  ) : (
                    <span className="text-muted">N/A</span>
                  )}
                </td>
                <td className="small">
                  {event?.email || <span className="text-muted">N/A</span>}
                </td>
                <td>
                  {event?.rejectReason ? (
                    <span className="text-danger small">
                      {event.rejectReason}
                    </span>
                  ) : (
                    <span className="text-muted">N/A</span>
                  )}
                </td>
                <td className="small">
                  {event?.happenedAt ? (
                    AxisDateTimeFull(event.happenedAt)
                  ) : (
                    <span className="text-muted">N/A</span>
                  )}
                </td>
                <td className="small">
                  {AxisDateTimeFull(event?.receivedAt)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Fragment>
  );
};

export default RefereeEventsElement;